import { BASE } from "../lib/env";
import type { Manifest } from "../models";

export async function loadManifest(): Promise<Manifest> {
  const res = await fetch(`${BASE}/data/manifest.json`);
  if (!res.ok) throw new Error(`manifest fetch failed: ${res.status}`);
  const data = (await res.json()) as Manifest;
  if (data.schema_version !== "1") {
    throw new Error(`manifest schema_version ${data.schema_version} unsupported`);
  }
  return data;
}

export function dataUri(path: string): string {
  // The on-disk session_uri is "data/sessions/{id}.json"; the frontend serves it from BASE/data/...
  return `${BASE}/${path.replace(/^\/+/, "")}`;
}
